import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }


import { useI18n } from '@shell/composables/useI18n';
import { _VIEW } from '@shell/config/query-params';
import { useStore } from 'vuex';
import Tab from '@shell/components/Tabbed/Tab.vue';

export interface Props {
  resource: any;
  component: any;
  resourceType: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigTab',
  props: {
    resource: {},
    component: {},
    resourceType: {}
  },
  setup(__props: any) {

const props = __props;
const store = useStore();
const i18n = useI18n(store);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tab, {
    class: "config-tab",
    name: "config-tab",
    label: _unref(i18n).t('component.drawer.resourceDetailDrawer.configTab.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(props.component), {
          value: props.resource,
          liveValue: props.resource,
          resourceType: props.resourceType,
          mode: _unref(_VIEW),
          "real-mode": _unref(_VIEW),
          "initial-value": props.resource,
          "use-tabbed-hash": false /* Have to disable hashing on child components or it modifies the url and closes the drawer */,
          as: "config"
        }, null, 8, ["value", "liveValue", "resourceType", "mode", "real-mode", "initial-value"]))
      ])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})